import update from 'immutability-helper'
import { createReducer } from '@reduxjs/toolkit'

import { updateItem } from '../../helpers/reducerHelpers'
import {
  GET_AD_SERVER_LIST,
  GET_AD_SERVER_LIST_FAILURE,
  GET_AD_SERVER_LIST_SUCCESS,
  CLEAR_GET_AD_SERVER_LIST,
  CREATE_AD_SERVER,
  CREATE_AD_SERVER_FAILURE,
  CREATE_AD_SERVER_SUCCESS,
  CLEAR_CREATE_AD_SERVER,
  UPDATE_AD_SERVER,
  UPDATE_AD_SERVER_FAILURE,
  UPDATE_AD_SERVER_SUCCESS,
  CLEAR_UPDATE_AD_SERVER,
  GET_AD_SERVER_LINE_ITEMS,
  GET_AD_SERVER_LINE_ITEMS_SUCCESS,
  GET_AD_SERVER_LINE_ITEMS_FAILURE,
  CLEAR_GET_AD_SERVER_LINE_ITEMS
} from '../actions/adServer'

import {
  INITIAL_CREATE_REDUCER,
  INITIAL_UPDATE_REDUCER,
  INITIAL_GET_RESULTS_REDUCER,
  InitialCreateReducer,
  InitialUpdateReducer,
  InitialGetResultsReducer
} from '../../constants/reducer'
import {
  CreateAdServerFailurePayload,
  CreateAdServerSuccessPayload,
  GetAdServerLineItemsFailurePayload,
  GetAdServerLineItemsSuccessPayload,
  GetAdServerListFailurePayload,
  GetAdServerListSuccessPayload,
  UpdateAdServerFailurePayload,
  UpdateAdServerSuccessPayload
} from '../types/adServer'

export type AdServerInitialStateType = {
  adServerList: InitialGetResultsReducer
  createAdServer: InitialCreateReducer
  updateAdServer: InitialUpdateReducer
  adServerLineItems: InitialGetResultsReducer
}

const initialState: AdServerInitialStateType = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  adServerList: INITIAL_GET_RESULTS_REDUCER,
  createAdServer: INITIAL_CREATE_REDUCER,
  updateAdServer: INITIAL_UPDATE_REDUCER,
  adServerLineItems: INITIAL_GET_RESULTS_REDUCER
}

export default createReducer(initialState, builder => {
  builder
    .addCase(GET_AD_SERVER_LIST, state => {
      return update(state, {
        adServerList: {
          $merge: {
            isLoading: true
          }
        }
      })
    })
    .addCase(GET_AD_SERVER_LIST_SUCCESS, (state, action: GetAdServerListSuccessPayload) => {
      return update(state, {
        adServerList: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data.results
          }
        }
      })
    })
    .addCase(GET_AD_SERVER_LIST_FAILURE, (state, action: GetAdServerListFailurePayload) => {
      return update(state, {
        adServerList: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_GET_AD_SERVER_LIST, state => {
      return update(state, {
        adServerList: { $set: initialState.adServerList }
      })
    })
    .addCase(CREATE_AD_SERVER, state => {
      return update(state, {
        createAdServer: { $merge: { isLoading: true } }
      })
    })
    .addCase(CREATE_AD_SERVER_SUCCESS, (state, action: CreateAdServerSuccessPayload) => {
      return update(state, {
        createAdServer: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        },
        adServerList: {
          results: {
            $unshift: [action.data]
          }
        }
      })
    })
    .addCase(CREATE_AD_SERVER_FAILURE, (state, action: CreateAdServerFailurePayload) => {
      return update(state, {
        createAdServer: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_CREATE_AD_SERVER, state => {
      return update(state, {
        createAdServer: { $set: initialState.createAdServer }
      })
    })
    .addCase(UPDATE_AD_SERVER, state => {
      return update(state, {
        updateAdServer: { $merge: { isLoading: true } }
      })
    })
    .addCase(UPDATE_AD_SERVER_SUCCESS, (state, action: UpdateAdServerSuccessPayload) => {
      return update(state, {
        updateAdServer: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        },
        adServerList: {
          results: {
            $apply: (items: object[]) => updateItem(items, action.data)
          }
        }
      })
    })
    .addCase(UPDATE_AD_SERVER_FAILURE, (state, action: UpdateAdServerFailurePayload) => {
      return update(state, {
        updateAdServer: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_UPDATE_AD_SERVER, state => {
      return update(state, {
        updateAdServer: { $set: initialState.updateAdServer }
      })
    })
    .addCase(GET_AD_SERVER_LINE_ITEMS, state => {
      return update(state, {
        adServerLineItems: { $merge: { isLoading: true } }
      })
    })
    .addCase(GET_AD_SERVER_LINE_ITEMS_SUCCESS, (state, action: GetAdServerLineItemsSuccessPayload) => {
      return update(state, {
        adServerLineItems: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    })
    .addCase(GET_AD_SERVER_LINE_ITEMS_FAILURE, (state, action: GetAdServerLineItemsFailurePayload) => {
      return update(state, {
        adServerLineItems: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    })
    .addCase(CLEAR_GET_AD_SERVER_LINE_ITEMS, state => {
      return update(state, {
        adServerLineItems: { $set: initialState.adServerLineItems }
      })
    })
})
